// extracted by mini-css-extract-plugin
export default {"wrapper":"VariantsTabContent_wrapper__NQqbT"};